// import React, { useState, forwardRef, useEffect } from "react";
// import {
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   Button,
//   Spinner,
//   FormFeedback,
// } from "reactstrap";
// import { db } from "../firebase";
// import {
//   collection,
//   addDoc,
//   updateDoc,
//   arrayUnion,
//   setDoc,
//   doc,
//   getDoc,
// } from "firebase/firestore";
// import PhoneInput from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import axios from "axios";
// import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
// import { useTranslation } from "react-i18next";

// const AppointmentForm = forwardRef(
//   ({ imageNumber, side = "left", styles = {}, ...props }, reference) => {
//     const [formData, setFormData] = useState({
//       date: "",
//       time: "",
//       name: "",
//       phone: "",
//       // email: "",
//       concern: "",
//       status: "requested",
//     });
//     const [loading, setLoading] = useState(false);
//     const [success, setSuccess] = useState(false);
//     const [errors, setErrors] = useState({
//       date: "",
//       time: "",
//       name: "",
//       phone: "",
//       // email: "",
//       concern: "",
//     });
//     const { t } = useTranslation();
//     const handleInputChange = (e) => {
//       const { name, value } = e.target;
//       setFormData((prevData) => ({ ...prevData, [name]: value }));
//       setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

//       // Date Validation: Ensure it's a future date
//       if (name === "date") {
//         if (new Date(value) <= new Date()) {
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             date: "Please select a future date.",
//           }));
//         } else {
//           setErrors((prevErrors) => ({ ...prevErrors, date: "" }));
//         }
//       }

//       // Time Validation: Ensure it is within allowed ranges
//       if (name === "time") {
//         const time = value;
//         const [hours, minutes] = time.split(":").map(Number);

//         // Check if the time is within the allowed ranges
//         const isWithinRange =
//           (hours >= 10 && hours < 13) || // 10 AM - 1 PM
//           (hours === 17 && minutes >= 0) || // 5 PM onwards
//           (hours === 18 && minutes >= 0) || // 6 PM onwards
//           (hours === 19 && minutes <= 30); // Up to 7:30 PM

//         if (!isWithinRange) {
//           setErrors((prevErrors) => ({
//             ...prevErrors,
//             time: "Please select a time between 10:00 AM - 1:00 PM or 5:00 PM - 7:30 PM.",
//           }));
//         } else {
//           setErrors((prevErrors) => ({ ...prevErrors, time: "" }));
//         }
//       }
//     };

//     useEffect(() => {
//       const validTimes = [
//         "10:00",
//         "10:30",
//         "11:00",
//         "11:30",
//         "12:00",
//         "12:30",
//         "13:00",
//         "17:00",
//         "17:30",
//         "18:00",
//         "18:30",
//         "19:00",
//       ];

//       // Check if time is valid, if it is, clear the error
//       if (formData.time && validTimes.includes(formData.time)) {
//         setErrors((prevErrors) => ({ ...prevErrors, time: "" }));
//       }
//     }, [formData.time]); // Trigger this effect when formData.time changes

//     const handlePhoneChange = (value) => {
//       setFormData((prevData) => ({ ...prevData, phone: value }));
//       setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
//     };
//     const [imageArray, setImageArray] = useState([]);
//     useEffect(() => {
//       const fetchImages = async () => {
//         const storage = getStorage();
//         const storageRef = ref(storage, "appointment");
//         try {
//           const result = await listAll(storageRef);
//           const urls = await Promise.all(
//             result.items.map((itemRef) => getDownloadURL(itemRef))
//           );
//           setImageArray(urls);
//         } catch (error) {
//           console.error("Error fetching images:", error);
//         }
//       };
//       fetchImages();
//     }, []);

//     const validateForm = () => {
//       let formIsValid = true;
//       let formErrors = { ...errors };

//       if (!formData.name.trim()) {
//         formErrors.name = "Name is required.";
//         formIsValid = false;
//       }

//       // if (!formData.concern.trim()) {
//       //   formErrors.concern = "Please describe your issue.";
//       //   formIsValid = false;
//       // }

//       // const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
//       // if (!formData.email.trim()) {
//       //   formErrors.email = "Email is required.";
//       //   formIsValid = false;
//       // } else if (!emailPattern.test(formData.email)) {
//       //   formErrors.email = "Please enter a valid email address.";
//       //   formIsValid = false;
//       // }

//       if (!formData.phone.trim()) {
//         formErrors.phone = "Phone number is required.";
//         formIsValid = false;
//       }

//       if (!formData.date) {
//         formErrors.date = "Appointment date is required.";
//         formIsValid = false;
//       } else if (new Date(formData.date) <= new Date()) {
//         formErrors.date = "Please select a future date.";
//         formIsValid = false;
//       }

//       if (!formData.time) {
//         formErrors.time = "Appointment time is required.";
//         formIsValid = false;
//       }

//       setErrors(formErrors);
//       return formIsValid;
//     };

//     const handleSubmit = async (e) => {
//       e.preventDefault();
//       if (!validateForm()) return;

//       setLoading(true);
//       setSuccess(false);
//       const combinedDateTime = `${formData.date}T${formData.time}`;
//       const requestedDate = new Date(combinedDateTime);

//       try {
//         const patientRef = doc(db, "patientsData", formData.phone);
//         const patientSnapshot = await getDoc(patientRef);

//         let patientExists = false;

//         if (patientSnapshot.exists()) {
//           patientExists = true;
//         } else {
//           await setDoc(patientRef, {
//             phone: formData.phone,
//             name: formData.name,
//             // email: formData.email,
//             appointments: [],
//             createdAt: new Date(),
//           });
//           console.log("Patient data created successfully!");
//         }

//         const appointmentRef = await addDoc(collection(db, "appointments"), {
//           date: formData.date,
//           time: formData.time,
//           phone: formData.phone,
//           requestedDate,
//           name: formData.name,
//           createdAt: new Date(),
//         });

//         console.log(
//           "Appointment added successfully with ID:",
//           appointmentRef.id
//         );

//         if (patientExists) {
//           await updateDoc(patientRef, {
//             appointments: arrayUnion(appointmentRef.id),
//           });
//           console.log("Appointment ID added to patient's appointments list.");
//         } else {
//           await updateDoc(patientRef, {
//             appointments: [appointmentRef.id],
//           });
//           console.log(
//             "Appointment ID added to newly created patient's appointments list."
//           );
//         }
//         // const response = await fetch(
//         //   "https://us-central1-lakdawalaeyehospital-f9656.cloudfunctions.net/appointmentRequestEmail",
//         //   {
//         //     method: "POST",
//         //     headers: {
//         //       "Content-Type": "application/json",
//         //     },
//         //     body: JSON.stringify({ ...formData, requestedDate }),
//         //   }
//         // );

//         // if (response.ok) {
//         //   console.log("Email sent successfully!");
//         // } else {
//         //   console.error("Failed to send email");
//         // }
//         const smsResponse = await axios.post(
//           "https://uzqjjogjuolaxcjdjpckj3vpim0obefc.lambda-url.ap-south-1.on.aws/",
//           {
//             phoneNumber: formData.phone,
//             message: `Dear ${formData.name},\n\nYour appointment request has been submitted at Dr. Lakdawala Eye Hospital.\n\nDate: ${formData.date}\nTime: ${formData.time}\nConcern: ${formData.concern}\n\nYou will be contacted soon for further details.\n\nThank you!`,
//           },
//           {
//             headers: {
//               "x-api-key": "dcf7a832-18a8-4f45-9b7e-1ae6c377d618",
//             },
//           }
//         );

//         if (smsResponse.status === 200) {
//           console.log("SMS sent successfully!");
//         } else {
//           console.error("Failed to send SMS");
//         }

//         setSuccess(true);
//         setFormData({
//           name: "",
//           // concern: "",
//           // email: "",
//           phone: "",
//           date: "",
//           time: "",
//         });
//       } catch (error) {
//         console.error("Error processing appointment request:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     return (
//       <section
//         ref={reference}
//         className="appointment-section section-gap"
//         style={styles?.section}
//       >
//         <div className="container">
//           <div className="row">
//             <div
//               className={`col-lg-7 ${side === "left" ? "" : "order-lg-2"}`}
//               style={styles?.formWrapper}
//             >
//               <div
//                 className="form-wrap p-4 shadow-sm rounded"
//                 style={styles?.formWrap}
//               >
//                 <div className="section-heading mb-4">
//                   <span
//                     // style={styles?.tagline}
//                     style={{
//                       color: "var(--color-fourth)",
//                       fontSize: "18px",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {t("appointmentForm.makeAppointment")}
//                   </span>
//                   <h2 className="title text-dark" style={styles?.title}>
//                     {t("appointmentForm.scheduleText")}
//                   </h2>
//                 </div>
//                 <Form onSubmit={handleSubmit}>
//                   <FormGroup>
//                     <Label for="name">
//                       {t("appointmentForm.yourFullName")}
//                     </Label>
//                     <Input
//                       type="text"
//                       id="name"
//                       name="name"
//                       placeholder={t("appointmentForm.yourFullName")}
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       invalid={!!errors.name}
//                       style={styles?.input}
//                     />
//                     {errors.name && <FormFeedback>{errors.name}</FormFeedback>}
//                   </FormGroup>
//                   {/**
//                   <FormGroup>
//                     <Label for="concern">
//                       {t("appointmentForm.howCanWeHelp")}
//                     </Label>
//                     <Input
//                       type="textarea"
//                       id="concern"
//                       name="concern"
//                       placeholder={t("appointmentForm.describeConcern")}
//                       value={formData.concern}
//                       onChange={handleInputChange}
//                       rows={4}
//                       invalid={!!errors.concern}
//                       style={styles?.input}
//                     />
//                     {errors.concern && (
//                       <FormFeedback>{errors.concern}</FormFeedback>
//                     )}
//                   </FormGroup>
//  */}
//                   {/**
//                   <FormGroup>
//                     <Label for="email"> {t("appointmentForm.email")}</Label>
//                     <Input
//                       type="email"
//                       id="email"
//                       name="email"
//                       placeholder={t("appointmentForm.email")}
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       invalid={!!errors.email}
//                       style={styles?.input}
//                     />
//                     {errors.email && (
//                       <FormFeedback>{errors.email}</FormFeedback>
//                     )}
//                   </FormGroup>
//  */}
//                   <FormGroup>
//                     <Label for="phone">{t("appointmentForm.phone")}</Label>
//                     <PhoneInput
//                       international
//                       defaultCountry="IN"
//                       value={formData.phone}
//                       onChange={handlePhoneChange}
//                       invalid={!!errors.phone}
//                       style={styles?.input}
//                     />
//                     {errors.phone && (
//                       <FormFeedback>{errors.phone}</FormFeedback>
//                     )}
//                   </FormGroup>

//                   <FormGroup className="d-flex" style={styles?.dateTime}>
//                     <div className="w-50 pe-2">
//                       <Label for="date">{t("appointmentForm.date")}</Label>
//                       <Input
//                         type="date"
//                         id="date"
//                         name="date"
//                         value={formData.date}
//                         onChange={handleInputChange}
//                         invalid={!!errors.date}
//                         style={styles?.input}
//                       />
//                       {errors.date && (
//                         <FormFeedback>{errors.date}</FormFeedback>
//                       )}
//                     </div>
//                     <div className="w-50 ps-2">
//                       <Label for="time">{t("appointmentForm.time")}</Label>
//                       <Input
//                         type="time"
//                         id="time"
//                         name="time"
//                         value={formData.time}
//                         onChange={handleInputChange}
//                         invalid={!!errors.time}
//                         style={styles?.input}
//                       />
//                       {errors.time && (
//                         <FormFeedback>{errors.time}</FormFeedback>
//                       )}
//                     </div>
//                   </FormGroup>

//                   <Button
//                     color="primary"
//                     type="submit"
//                     className="w-100 d-flex justify-content-center align-items-center"
//                     disabled={loading}
//                     style={{
//                       backgroundColor: success
//                         ? "green"
//                         : "var(--color-fourth)",
//                       color: success ? "white" : "white",
//                       borderColor: success ? "none" : "var(--color-fourth)",
//                       ...styles?.button,
//                     }}
//                   >
//                     {loading ? (
//                       <>
//                         <Spinner size="sm" className="me-2" /> Submitting...
//                       </>
//                     ) : success ? (
//                       " ✔ Appointment Scheduled"
//                     ) : (
//                       t("appointmentForm.appointmentButton")
//                     )}
//                   </Button>
//                 </Form>
//               </div>
//             </div>

//             <div className={`col-lg-5 ${side === "left" ? "" : "order-lg-1"}`}>
//               <div
//                 className="appointment-image w-100 rounded"
//                 style={{
//                   backgroundImage: `url(${imageArray[imageNumber]})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   height: "100%",
//                   objectFit: "cover",
//                   minHeight: "400px",
//                   ...styles?.image,
//                 }}
//                 loading="lazy"
//               ></div>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }
// );

// export default AppointmentForm;

import React, { useState, forwardRef, useEffect } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  FormFeedback,
} from "reactstrap";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  updateDoc,
  arrayUnion,
  setDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
import { useTranslation } from "react-i18next";

const AppointmentForm = forwardRef(
  ({ imageNumber, side = "left", styles = {}, ...props }, reference) => {
    const { i18n } = useTranslation();
    const [formData, setFormData] = useState({
      date: "",
      time: "",
      name: "",
      phone: "",
      status: "requested",
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errors, setErrors] = useState({
      date: "",
      time: "",
      name: "",
      phone: "",
    });
    const { t } = useTranslation();
    const convertTo12HourFormat = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      const suffix = hours >= 12 ? "PM" : "AM";
      const hours12 = hours % 12 || 12;
      const minutesFormatted = minutes.toString().padStart(2, "0");
      return `${hours12
        .toString()
        .padStart(2, "0")}:${minutesFormatted}${suffix}`;
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    };
    const isSunday = (dateString) => {
      const date = new Date(dateString);
      return date.getDay() === 0; // 0 = Sunday
    };
    const [formattedPhone, setFormattedPhone] = useState("");
    const generateAvailableTimes = () => {
      const now = new Date();
      const today = new Date(formData.date);
      today.setHours(0, 0, 0, 0);

      const validTimes = [
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
      ];

      return validTimes.filter((time) => {
        const [hours, minutes] = time.split(":").map(Number);
        const selectedTime = new Date(formData.date);
        selectedTime.setHours(hours, minutes, 0, 0);

        // If selecting today, disable past times
        if (today.getTime() === now.setHours(0, 0, 0, 0)) {
          return selectedTime > now;
        }

        return true; // Allow all times for future dates
      });
    };

    console.log("THISLANGUAGE", i18n.language);
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({ ...prevData, [name]: value }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time for accurate date comparison
      const selectedDate = new Date(value);
      if (name === "date") {
        if (selectedDate < today) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            date: "Please select today or a future date.",
          }));
        } else if (isSunday(value)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            date: "Appointments are not available on Sundays. Please select another date.",
          }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, date: "" }));
        }
      }
      if (name === "time") {
        const [hours, minutes] = value.split(":").map(Number);
        const now = new Date();
        const selectedTime = new Date(formData.date);
        selectedTime.setHours(hours, minutes, 0, 0);

        // Define allowed time slots
        const isWithinRange =
          (hours >= 10 && hours < 13) || // 10 AM - 1 PM
          (hours === 17 && minutes >= 0) || // 5 PM onwards
          (hours === 18 && minutes >= 0) || // 6 PM onwards
          (hours === 19 && minutes <= 30); // Up to 7:30 PM

        if (!isWithinRange) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            time: "Please select a time between 10:00 AM - 1:00 PM or 5:00 PM - 7:30 PM.",
          }));
        } else if (
          selectedDate.getTime() === today.getTime() &&
          selectedTime <= now
        ) {
          // Prevent selecting past times on the same day
          setErrors((prevErrors) => ({
            ...prevErrors,
            time: "Please select a future time.",
          }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, time: "" }));
        }
      }
    };
    const getAvailableTimes = (selectedDate) => {
      const now = new Date();
      const selected = new Date(selectedDate);
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();

      // Define allowed time slots
      const validTimes = [
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
      ];

      if (selected.toDateString() === now.toDateString()) {
        // If the selected date is today, disable past times
        return validTimes.map((time) => {
          const [hours, minutes] = time.split(":").map(Number);
          const isPast =
            hours < currentHours ||
            (hours === currentHours && minutes <= currentMinutes);
          return { time, disabled: isPast };
        });
      }

      // If it's a future date, return all times as enabled
      return validTimes.map((time) => ({ time, disabled: false }));
    };

    useEffect(() => {
      const validTimes = [
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
      ];

      if (formData.time && validTimes.includes(formData.time)) {
        setErrors((prevErrors) => ({ ...prevErrors, time: "" }));
      }
    }, [formData.time]);

    const handlePhoneChange = (value) => {
      setFormattedPhone(value);
      if (value) {
        setFormData((prevData) => ({
          ...prevData,
          phone: value.replace(/[^0-9]/g, ""),
        }));
      } else {
        setFormData((prevData) => ({ ...prevData, phone: "" }));
      }
      setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
    };

    const [imageArray, setImageArray] = useState([]);
    useEffect(() => {
      const fetchImages = async () => {
        const storage = getStorage();
        const storageRef = ref(storage, "appointment");
        try {
          const result = await listAll(storageRef);
          const urls = await Promise.all(
            result.items.map((itemRef) => getDownloadURL(itemRef))
          );
          setImageArray(urls);
        } catch (error) {
          console.error("Error fetching images:", error);
        }
      };
      fetchImages();
    }, []);

    const validateForm = () => {
      let formIsValid = true;
      let formErrors = { ...errors };

      if (!formData.name.trim()) {
        formErrors.name = "Name is required.";
        formIsValid = false;
      }

      if (!formData.phone.trim()) {
        formErrors.phone = "Phone number is required.";
        formIsValid = false;
      }
      if (!formData.date) {
        formErrors.date = "Appointment date is required.";
        formIsValid = false;
      } else {
        const selectedDate = new Date(formData.date);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time for accurate date comparison

        if (selectedDate < today) {
          formErrors.date = "Please select today or a future date.";
          formIsValid = false;
        } else if (isSunday(formData.date)) {
          formErrors.date =
            "Appointments are not available on Sundays. Please select another date.";
          formIsValid = false;
        }
      }
      if (!formData.time) {
        formErrors.time = "Appointment time is required.";
        formIsValid = false;
      } else {
        // Check if time is valid based on your custom time validation logic
        const time = formData.time;
        const [hours, minutes] = time.split(":").map(Number);

        const isWithinRange =
          (hours >= 10 && hours < 13) || // 10 AM - 1 PM
          (hours === 17 && minutes >= 0) || // 5 PM onwards
          (hours === 18 && minutes >= 0) || // 6 PM onwards
          (hours === 19 && minutes <= 30); // Up to 7:30 PM

        if (!isWithinRange) {
          formErrors.time =
            "Please select a time between 10:00 AM - 1:00 PM or 5:00 PM - 7:30 PM.";
          formIsValid = false;
        }
      }

      // Set errors in state
      setErrors(formErrors);

      // Return the form validity flag
      return formIsValid;
    };
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) return;

      setLoading(true);
      setSuccess(false);
      const combinedDateTime = `${formData.date}T${formData.time}`;
      const requestedDate = new Date(combinedDateTime);

      try {
        const patientRef = doc(db, "patientsData", formData.phone);
        const patientSnapshot = await getDoc(patientRef);

        let patientExists = false;

        if (patientSnapshot.exists()) {
          patientExists = true;
        } else {
          await setDoc(patientRef, {
            phone: formData.phone,
            name: formData.name,
            appointments: [],
            createdAt: new Date(),
          });
          console.log("Patient data created successfully!");
        }
        const formattedTime = convertTo12HourFormat(formData.time);
        const formattedDate = formatDate(formData.date);

        let language = i18n.language;
        if (language === "en" || language === "en-US") {
          language = "en_US";
        }

        const appointmentRef = await addDoc(collection(db, "appointments"), {
          date: formattedDate,
          time: formattedTime,
          phone: formData.phone,
          requestedDate,
          name: formData.name,
          createdAt: new Date(),
          language: language,
          status: "Approved",
        });

        console.log(
          "Appointment added successfully with ID:",
          appointmentRef.id
        );

        if (patientExists) {
          await updateDoc(patientRef, {
            appointments: arrayUnion(appointmentRef.id),
          });
          console.log("Appointment ID added to patient's appointments list.");
        } else {
          await updateDoc(patientRef, {
            appointments: [appointmentRef.id],
          });
          console.log(
            "Appointment ID added to newly created patient's appointments list."
          );
        }

        // const smsResponse = await axios.post(
        //   "https://uzqjjogjuolaxcjdjpckj3vpim0obefc.lambda-url.ap-south-1.on.aws/",
        //   {
        //     phoneNumber: formData.phone,
        //     message: `Dear ${
        //       formData.name
        //     },\n\nYour appointment request has been submitted at Dr. Lakdawala Eye Hospital.\n\nDate: ${formatDate(
        //       formData.date
        //     )}\nTime: ${convertTo12HourFormat(
        //       formData.time
        //     )}\n\nYou will be contacted soon for further details.\n\nThank you!`,
        //   },

        //   {
        //     headers: {
        //       "x-api-key": "dcf7a832-18a8-4f45-9b7e-1ae6c377d618",
        //     },
        //   }
        // );

        // if (smsResponse.status === 200) {
        //   console.log("SMS sent successfully!");
        // } else {
        //   console.error("Failed to send SMS");
        // }

        setSuccess(true);
        setFormData({
          name: "",
          phone: "",
          date: "",
          time: "",
          status: "approved",
        });
      } catch (error) {
        console.error("Error processing appointment request:", error);
      } finally {
        setLoading(false);
      }
    };

    return (
      <section
        ref={reference}
        className="appointment-section section-gap"
        style={styles?.section}
      >
        <div className="container">
          <div className="row">
            <div
              className={`col-lg-7 ${side === "left" ? "" : "order-lg-2"}`}
              style={styles?.formWrapper}
            >
              <div
                className="form-wrap p-4 shadow-sm rounded"
                style={styles?.formWrap}
              >
                <div className="section-heading mb-4">
                  <span
                    style={{
                      color: "var(--color-fourth)",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    {t("appointmentForm.makeAppointment")}
                  </span>
                  <h2 className="title text-dark" style={styles?.title}>
                    {t("appointmentForm.scheduleText")}
                  </h2>
                </div>
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label for="name">
                      {t("appointmentForm.yourFullName")}
                    </Label>
                    <Input
                      type="text"
                      id="name"
                      name="name"
                      placeholder={t("appointmentForm.yourFullName")}
                      value={formData.name}
                      onChange={handleInputChange}
                      invalid={!!errors.name}
                      style={styles?.input}
                    />
                    {errors.name && <FormFeedback>{errors.name}</FormFeedback>}
                  </FormGroup>
                  <FormGroup>
                    <Label for="phone">{t("appointmentForm.phone")}</Label>
                    <PhoneInput
                      international
                      defaultCountry="IN"
                      value={formattedPhone}
                      onChange={handlePhoneChange}
                      invalid={!!errors.phone}
                      style={styles?.input}
                    />
                    {errors.phone && (
                      <FormFeedback>{errors.phone}</FormFeedback>
                    )}
                  </FormGroup>

                  <FormGroup className="d-flex" style={styles?.dateTime}>
                    <div className="w-50 pe-2">
                      <Label for="date">{t("appointmentForm.date")}</Label>
                      <Input
                        type="date"
                        id="date"
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        invalid={!!errors.date}
                        style={styles?.input}
                        min={new Date().toISOString().split("T")[0]}
                      />
                      {errors.date && (
                        <FormFeedback>{errors.date}</FormFeedback>
                      )}
                    </div>
                    <div className="w-50 ps-2">
                      <Label for="time">{t("appointmentForm.time")}</Label>
                      <Input
                        type="select"
                        name="time"
                        id="time"
                        value={formData.time}
                        onChange={handleInputChange}
                      >
                        {getAvailableTimes(formData.date).map(
                          ({ time, disabled }) => (
                            <option key={time} value={time} disabled={disabled}>
                              {convertTo12HourFormat(time)}
                            </option>
                          )
                        )}
                      </Input>
                      {errors.time && (
                        <FormFeedback>{errors.time}</FormFeedback>
                      )}
                    </div>
                  </FormGroup>

                  <Button
                    color="primary"
                    type="submit"
                    className="w-100 d-flex justify-content-center align-items-center"
                    disabled={loading}
                    style={{
                      backgroundColor: success
                        ? "green"
                        : "var(--color-fourth)",
                      color: success ? "white" : "white",
                      borderColor: success ? "none" : "var(--color-fourth)",
                      ...styles?.button,
                    }}
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" className="me-2" /> Submitting...
                      </>
                    ) : success ? (
                      " ✔ Appointment Scheduled"
                    ) : (
                      t("appointmentForm.appointmentButton")
                    )}
                  </Button>
                </Form>
              </div>
            </div>

            <div className={`col-lg-5 ${side === "left" ? "" : "order-lg-1"}`}>
              <div
                className="appointment-image w-100 rounded"
                style={{
                  backgroundImage: `url(${imageArray[imageNumber]})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  objectFit: "cover",
                  minHeight: "400px",
                  ...styles?.image,
                }}
                loading="lazy"
              ></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
);

export default AppointmentForm;
